// Round 3 Lane 6 copy: other cities and trips (R-41, R-42). Opus draft, Astra pass: Astra was not reachable during the
// round, so Opus drafted these and Claude gated them (AGENTS.md: "If Astra is unavailable, Opus covers"). Sentence case,
// no dashes or exclamation marks, "activities" not "listings", nothing promised that is not built (no message is sent
// yet: the city-ready line says we keep the wish, not that we will text or email).
export const RC = {
  // city switcher (Browse hero and Settings)
  'rc.change': 'Change city',
  'rc.sheet_title': 'Choose a city',
  'rc.sheet_sub': 'Los Angeles is our home. These cities are ready too.',
  'rc.home': 'Back to {home}',
  'rc.places': '{count} activities',
  'rc.other_label': 'Another city',
  'rc.other_placeholder': 'Type a city, like Austin',
  'rc.other_go': 'Go',
  'rc.loading': 'Loading cities',
  'rc.error': 'We could not load the list of cities. You can still type one below.',
  // a city that is not ready (added under the existing "getting ready" panel and its failed state)
  'rc.wish_saved': 'We saved {city} for you. It will show here as soon as it is ready.',
  'rc.not_ready_title': '{city} is not ready yet',
  'rc.not_ready_body': 'We saved it for you. Look again later, or browse Los Angeles in the meantime.',
  // Settings
  'rc.settings_title': 'Cities',
  'rc.settings_sub': 'Browse another city, or plan a trip across a few.',
  'rc.settings_browse': 'Browse another city',
  'rc.settings_waiting': 'Waiting for',
  'rc.settings_ready': '{city} is ready',
  'rc.settings_getting': '{city}: getting ready',
  'rc.settings_remove': 'Remove {city}',
  'rc.trip_new': 'Plan a trip across cities',
  // trip: new
  'rc.trip_title': 'Plan a trip',
  'rc.trip_sub': 'Add each city with your dates there. Where you are staying is optional; it helps us show what is close.',
  'rc.trip_city': 'City {n}',
  'rc.trip_place': 'City',
  'rc.trip_from': 'First day',
  'rc.trip_to': 'Last day',
  'rc.trip_stay': 'Where you are staying (optional)',
  'rc.trip_stay_placeholder': 'A hotel, street or neighborhood',
  'rc.trip_add_city': 'Add another city',
  'rc.trip_remove_city': 'Remove this city',
  'rc.trip_name': 'Trip name (optional)',
  'rc.trip_create': 'Make my trip',
  'rc.trip_making': 'Making your trip',
  'rc.trip_error': 'We could not make the trip: {reason}',
  'rc.trip_error_plain': 'We could not make the trip. Check your connection and try again.',
  // trip: view
  'rc.trip_back': 'Itineraries',
  'rc.trip_leg_dates': '{range}',
  'rc.trip_leg_stay': 'Staying at {stay}',
  'rc.trip_leg_count_one': '1 activity',
  'rc.trip_leg_count_other': '{count} activities',
  'rc.trip_leg_none': 'Nothing added yet',
  'rc.trip_leg_open': 'Open {city}',
  'rc.trip_leg_find': 'Find things in {city}',
  'rc.trip_leg_building': 'We are getting {city} ready. Check back soon.',
  'rc.trip_times': "Times are shown in each city's own time.",
  'rc.trip_not_found': 'We could not find this trip.',
  'rc.trip_part_of': 'Part of {trip}',
} as const

export type RcKey = keyof typeof RC
export function rc(key: RcKey, vars?: Record<string, string | number>): string {
  let s: string = RC[key]
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(String(v))
  return s
}
